import '../public/css/app.css';

export default function MyApp({ Component, pageProps }) {
  return <Component {...pageProps} />;
}